import React from 'react';

import values   from '../../../../values';
import Context  from '../../../../context';
import ShowInfo from './components/ShowInfo';

import { Components     } from './components';
import { useTranslation } from 'react-i18next';
import {
  BreadCrumb,
  Pagination,
  TableHeader,
  TableLoading,
  ResponsiveView,
} from '../../../../components';

import './index.scss';

type Props = {
  rqData       : any;
  showModalData: any;
};

const DriverTransactionScreen = (props: Props) => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const {
    requestDriverTransaction,
    setRequestDriverTransaction,
  } = React.useContext(Context.DriverTransactionScreen);

  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="transactions-screen">
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={5} large={7} medium={7} className="search-and-filter-wrapper">
          <div style={{display:"flex",alignItems:"center",gap:"1rem"}}>
            <Components.TimeFilter />
          </div>
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <ResponsiveView.Row>
        <ResponsiveView.Column medium={7}><div/></ResponsiveView.Column>
        <ResponsiveView.Column medium={5}>
          <ResponsiveView.Row>
            <ResponsiveView.Column medium={10} extraSmall={9}>
              <Components.Search />
            </ResponsiveView.Column>
            <ResponsiveView.Column medium={2} extraSmall={3}>
              <Components.Filter />
            </ResponsiveView.Column>
          </ResponsiveView.Row>
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.DRIVER_TRANSACTION.map((item) => t(item))}/>
            {props.rqData?.status === "loading" ? (<TableLoading />) : (<Components.Body data={props.rqData} />)}
          </table>
        </div>
        <div style={{display: "flex", justifyContent: "center", marginTop: "2rem", gap: "1rem",}}>
          <div></div>
        </div>
      </ResponsiveView.Container>
      {props.rqData?.status === "success" &&
        props.rqData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={requestDriverTransaction?.page}
              totalPages={props.rqData?.data?.result?.totalPages}
              onPaginate={(page: number) => setRequestDriverTransaction({...requestDriverTransaction, page: page,})}
            />
          </div>
        )}
      <ShowInfo />
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default DriverTransactionScreen;
